'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSpoon = function IoSpoon(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 12.5c0-5-2-10-5-10s-5 5-5 10c0.1 2 1.3 4.2 2.9 5l0.1 0.1c0.2 0.1 0.8 0.4 0.8 0.8 0 0-1.3 15.5-1.3 16.4s0.3 1.5 0.8 2 1.1 0.7 1.7 0.7 1.3-0.2 1.7-0.7 0.8-1 0.8-2-1.2-16.4-1.2-16.4c0-0.4 0.5-0.7 0.7-0.8l0.1-0.1c1.7-0.8 2.9-3 2.9-5z' })
        )
    );
};

exports.default = IoSpoon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/spoon.js
// module id = 2735
// module chunks = 0